import { render } from "./sub_request_approval.vue?vue&type=template&id=69004c64&scoped=true"
import script from "./sub_request_approval.vue?vue&type=script&lang=js"
export * from "./sub_request_approval.vue?vue&type=script&lang=js"

import "./sub_request_approval.vue?vue&type=style&index=0&id=69004c64&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69004c64"]])

export default __exports__